var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationSolidRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500244,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#BC0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41744 9.55353C7.42573 9.84503 7.66442 10.077 7.95603 10.077C8.24765 10.077 8.48634 9.84503 8.49462 9.55353L8.61888 5.1822C8.6295 4.80874 8.32965 4.50024 7.95603 4.50024C7.58242 4.50024 7.28257 4.80874 7.29318 5.1822L7.41744 9.55353ZM7.2002 11.7529C7.2002 12.1656 7.53479 12.5002 7.94754 12.5002H7.96453C8.37727 12.5002 8.71187 12.1656 8.71187 11.7529C8.71187 11.3401 8.37727 11.0056 7.96453 11.0056H7.94754C7.53479 11.0056 7.2002 11.3401 7.2002 11.7529Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationSolidRed);
export default __webpack_public_path__ + "static/media/exclamation_solid_red.1186c25dc833e8cdb8e3a19ab00136d7.svg";
export { ForwardRef as ReactComponent };